import React, { useEffect, useState, useCallback } from "react";
import AlertIconSVG from "assets/svg/alert-info-icon-sm-svg";
import { useDropzone } from "react-dropzone";
import ImageDropIconSVG from "assets/svg/image-drop-icon";
import { useDialogHook } from "utils/customhooks";
import UploadSizeModal from "components/file-upload/upload-size-modal";
import _ from "lodash";
import { maxUploadSize } from "utils/constant";
import { useTranslation } from "react-i18next";

const DropzoneUploaComponent = (
  {
    id = "media-upload",
    itemIndex = 0,
    userData,
    formContainer = "form-input-container",
    linkType,
    setItems = () => { },
    setProgress = () => { },
    progress = {},
    onUploadMultiple = () => { },
    icon = null,
    buttonText = "Browse Images",
    onUpload = () => { },
    errorMessage = null,
    fileSizeError = null,
    ...props
  },
  ref
) => {
  const { t } = useTranslation();
  const [error, setError] = useState(null)
  const { http } = global.services;
  const uploadSizeModal = useDialogHook(UploadSizeModal);

  const onDrop = (async acceptedFiles => {
    let indexTracker = 0;
    let IDArray = [];
    const linkTypeLength = linkType[itemIndex].value.length;
    for(const file of acceptedFiles) {
      if (file.size > maxUploadSize) {
        showUploadSizeModalError();
        return;
      }
      const randomId = Math.random().toString(36).substring(2, 7);
      IDArray.push(randomId);
      file.progress = 1;
      file.progressId = randomId;
    }

    await onUploadMultiple([...acceptedFiles]);

    for(const file of acceptedFiles) {
      onUploadImagesVideos(file, IDArray[indexTracker], linkTypeLength + indexTracker);
      indexTracker++;
    }

  });

  // ===================== functions =========================
    const onUploadImagesVideos = async (file, progressID, index) => {
      if (!file) return;

      // 1️⃣ Ask Laravel for presigned URL + key
      const extension = file.name.split('.').pop();
      const nameWithoutExt = file.name.substring(0, file.name.lastIndexOf('.'));
      const mime      = file.type;
      const { data: { url, key } } = await http.post(
        'public/milestones/presign',
        { file_name: nameWithoutExt, extension, mime, user_id: userData.user.id }
      );
      setProgress(prev => ({ ...prev, [progressID]: 0 }));

      // 2️⃣ Upload straight to S3
      await http.put(url, file, {
        headers: { 'Content-Type': mime, 'x-amz-acl':    'public-read' },
        onUploadProgress: e => {
          if (!e.total) return;
          const pct = Math.round((e.loaded / e.total) * 100)-1;
          setProgress(prev => ({ ...prev, [progressID]: pct }));
        }
      });

      // 3️⃣ Tell your server it’s done
      const { data } = await http.post(
        'public/milestones/confirm',
          {
            file_name: nameWithoutExt,
            extension,
            key,
            user_id: userData.user.id,
            size: file.size,
            mime: file.type
          }
      );

      // 4️⃣ Update your UI state
      setItems(prev => {
        const buffer = _.cloneDeep(prev);
        buffer[itemIndex].value[index] = data;
        return buffer;
      });
      setProgress(prev => ({
        ...prev,
        [progressID]: 100,
        refresh:      100
      }));
    };

  const showUploadSizeModalError = () => {
    uploadSizeModal({}, (callback) => {
      console.log('callback', callback)
    })
  }

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    noClickL: true,
    accept: {
      'image/*': [],
    }
  });

  useEffect(() => {
    if (errorMessage) {
      setError(errorMessage)
    }
  }, [errorMessage])

  return (
    <>
      <div className="relative h-14 image-dropzone flex">
            {/* dropzone */}
            <div {...getRootProps()}>
              <input ref={ref} {...getInputProps()} />
              <div className="add-photo-dropzone flex flex-wrap justify-center px-2">
                <ImageDropIconSVG />
                <p className="text-sm text-gray-500 mt-2 text-center">{t('dragDrop')} <span className="text-blue">{t('browseFiles')}</span></p>
              </div>
            </div>
      </div>
      {error && (
        <p className="input-error-message mt-2 -mb-1 flex">
          <AlertIconSVG /> {error}
        </p>
      )}
    </>
  );
};

const DropzoneUpload = React.forwardRef(DropzoneUploaComponent);

export default DropzoneUpload;
